module.exports = __webpack_public_path__ + "static/media/terraform.b0eeb8cb.avif";